<template>
    <app-page-error v-if="showErrorPage" />
    
    <!--<div v-else id="projectContainer" class="is-clipped " :class="embed ? 'lb-embed-height' : 'lb-full-height'">-->
    <div v-else id="projectContainer" class="is-clipped" :class="isEmbed ? 'lb-embed-height' : 'lb-full-height'">
        <div class="modal blockall" :class="{'is-active':bellowLimit}">
            <div class="modal-background"></div>
            <div class="modal-content">
                <div class="card">
                    <div class="card-content">
                        <div class="content">
                            {{$t('window_too_small')}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition :enter-active-class="isMobile ? 'animated slideInUp' : 'animated slideInLeft'"
            :leave-active-class="isMobile ? 'animated slideOutDown' : 'animated slideOutLeft'" mode="out-in">
            <project-configuration v-if="showMenu" ref="configuration" 
                :creationEnabled="creationEnabled"
                :editionEnabled="editionEnabled" 
                :content="contentDraft" 
                :model="contentModel" 
                :items="filteredItems"
                :showSettings="showSettings" 
                :showThreadList="showThreadList" 
                :showHistory="showHistory"
                :showListSessions="showListSessions" 
                :showSessionActive="showSessionActive" 
                :session="session"
                :hasLocation="hasLocation" 
                :showObjectList="showObjectList" 
                :hasDelete="hasDelete" 
                :objectType="objectType"
                :showHelp="showTreasurehuntHelp" 
                :showShare="showShare"
                @save="updateOrCreateObject" 
                @cancel="cancelInput"
                @close="showSettings = false" 
                @updateProject="updateProject" 
                @start-simulation="startSimulation"
                @delete="deleteObject" 
                @addPoint="addPoint" 
                @activateMapPosition="mapPositionActive = true"
                @searchObjects="searchObjects" 
                @centerMap="centerMap" 
                @toggleObjectList="toggleObjectList"
                @toggleActiveSession="toggleSessionActive" 
                @closeHistory="showHistory = false" 
                @showObjectPreview="showObjectPreview" 
                @saveMulti="updateOrCreateMulti"
                @closeShare="showShare = false"
                @saveMemoryObject="updateOrCreateMemoryObject"
                @editGameSession="editingSession=true"
                />
        </transition>

        <div class="columns is-marginless">

            <div class="is-scroll-hidden py-0 px-0 zindex10" :class="menuClasses" v-if="!hideProjectMenu">

                <project-configuration-menu :canCreateObject="canCreateObject" :creationEnabled="creationEnabled"
                    :canEditObject="canEditObject" :editionEnabled="editionEnabled" :isProjectAdmin="isProjectAdmin"
                    :isTrivial="isTrivial" :hasCreationPermission="hasCreationPermission"
                    :hasEditionPermission="hasEditionPermission" :projectFormat="project.format" :showHistory="showHistory"
                    :showSettings="showSettings" :showObjectList="showObjectList" :showingAnswers="showingAnswers"
                    :sessionStarted="sessionStarted" :sessionPaused="sessionPaused" :showListSessions="showListSessions"
                    :showActiveSession="showSessionActive" :objectType="objectType" :showShare="showShare"
                    @toggleAnswers="showingAnswers = !showingAnswers" @toggleHistory="toggleHistory"
                    @toggleSettings="toggleSettings" @toggleCreation="toggleCreation" @toggleObjectList="toggleObjectList"
                    @startSession="startSession" @pauseSession="pauseSession" @continueSession="continueSession"
                    @stopSession="stopSession" @toggleListSessions="toggleListSessions"
                    @toggleSessionActive="toggleSessionActive" @toggleShare="toggleShare" />
                <!--<div v-if="embed" class="logo-iframe">
                    <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt="eduloc360"
                    width="120"
                    height="50"
                />
                </div>-->

            </div>

            <div class="zone-content" :class="contentClasses">
                <div class="columns is-multiline">
                    <div class="column mt-4 is-4 is-offset-8" :class="isMobile ? 'px-5' : 'pr-6'"
                        v-if="project.mode != 'map' && project.type != 'treasurehunt' && project.format!='PROJECT_TYPE_MEMORY'">
                        <app-search-bar :placeholder="$t('search_text')" :filter.sync="typeFilter" :text.sync="searchValue"
                            class="mt-3" @input="searchObjects"/>
                    </div>
                </div>

                <component :is="getComponent" ref="content" :project-id="projectId" :items="filteredItems"
                    :draft="contentDraft" :modal-opened="showInputModal" :show-answers="showingAnswers"
                    :editionEnabled="editionEnabled" :creationEnabled="creationEnabled" :canEdit="isEditionBlocked"
                    :pointDraft="pointDraft" :mapPositionActive="mapPositionActive" :activeObject="activeObject"
                    :highlightedMarker="highlightedMarker" :selectedObjectMarker="selectedObjectMarker"
                    :selectedObject="selectedObject" :sessionStarted="sessionStarted" :sessionPaused="sessionPaused"
                    class="column is-12 is-paddingless" @edit-object="toggleEdition" @updatePointDraft="updateDraftPosition"
                    @addPoint="addPoint" @show="showObject" @addTreasurehuntObject="addTreasurehuntObject"
                    @highlightMarker="highlightMarker" @editTreasurehuntObject="editTreasurehuntObject"
                    @showTreasurehuntPreview="showTreasurehuntPreview"
                    @deleteTreasurehuntObject="deleteTreasurehuntObject" @zoomImage="zoomImage" @tooSmall="canBlockWindow"
                    :canCreateObject="canCreateObject" :needWays="needWays"/>
            </div>

            <router-view />

            <l-project-modal-session-creation v-if="startingSession" @close="startingSession = false"
                @sessionActivation="activateSession" />

            <div v-if="showSimulateSessionModal" class="is-clipped">
                <div class="modal-background has-scroll-y">
                    <component :is="simulatePlayComponent" @close="showSimulateSessionModal = false" />
                </div>
            </div>

            <l-project-modal-configuration-changes v-if="configurationChangesWarning && isProjectAdmin"
                @toggle-configuration="openConfiguration" />

            <project-session-details-modal v-if="showSessionDetails" @close="showSessionDetails = false" />

            <l-project-modal-session-edition v-if="editingSession" @close="closeEditSession" :session="session"/>

        </div>

        <!-- <l-project-object-preview
            :object="objectToView"
            v-if="showPreviewModal"
            @close="showPreviewModal = false"
        />-->
        <l-project-view-modal-content @edit-object="editObjectInit" :object="activeObject" v-if="showObjectModal"
            @close="closeObjectModal" :view-mode="sessionStarted && !sessionPaused" @zoomImage="zoomImage"></l-project-view-modal-content>

        <TreasurehuntPreview :objects="pathPreview" :startInObject="initialPreviewObject" :tileProvider="mapProvider"
            v-if="showTreasurehuntSessionPreview && pathPreview" @close="hideTreasurehuntPreview"
            class="treasurehunt-preview"></TreasurehuntPreview>

        <l-project-view-object-content :object="objectToPreview" v-if="showPreviewModal"
            @close="closeObjectPreviewModal" @zoomImage="zoomImage"></l-project-view-object-content>
        
        <image-view-modal :url="imageToView" v-if="viewImageModal" @close="closeImageModal"/>

    </div>
</template>

<script>
import ProjectHeader from '@/components/ProjectHeader';
import ProjectContent from '@/components/ProjectContent';
import ProjectContentMapV2 from '@/components/ProjectContentMapV2';
import ProjectConfiguration from '@/components/ProjectConfiguration';
import ProjectConfigurationMenu from '@/components/ProjectConfigurationMenu';
import ProjectSessionCreationModal from '@/components/ProjectSessionCreationModal';
import AppPageError from '@/components/AppPageError';
import AppSearchBar from '@/components/AppSearchBar';
import PlayQuiz from '@/components/PlayQuiz';
import store from '@/store/index';
import { Document } from 'flexsearch';
import _ from 'underscore';
import { isEmptyObject } from '@/lib/helpers';
import moment from 'moment';
import Swal from 'sweetalert2';
import { fetchItem, pauseSession, continueSession, stopSession } from '@/services/API';
import LProjectModalSessionCreation from '@/components/LProjectModalSessionCreation';
import LProjectModalConfigurationChanges from '@/components/LProjectModalConfigurationChanges';
import ProjectSessionDetailsModal from '@/components/ProjectSessionDetailsModal';
import LProjectViewModalContent from '@/components/LProjectViewModalContent';
import ProjectContentTreasureHunt from '@/components/ProjectContentTreasureHunt';
import TreasurehuntPreview from '@/components/TreasurehuntPreview';
import { TILE_PROVIDERS, DEFAULT_TILE_PROVIDER } from '@/lib/constants';
import LProjectViewObjectContent from '@/components/LProjectViewObjectContent';
import ImageViewModal from '@/components/ImageViewModal';
import LProjectModalSessionEdition from '@/components/LProjectModalSessionEdition';

export default {
    name: 'Project',
    components: {
        ProjectHeader,
        ProjectContent,
        ProjectConfiguration,
        ProjectSessionCreationModal,
        AppPageError,
        AppSearchBar,
        LProjectModalSessionCreation,
        LProjectModalConfigurationChanges,
        ProjectSessionDetailsModal,
        ProjectContentMapV2,
        ProjectConfigurationMenu,
        LProjectViewModalContent,
        ProjectContentTreasureHunt,
        TreasurehuntPreview,
        LProjectViewObjectContent,
        ImageViewModal,
        LProjectModalSessionEdition,
    },
    props: {
        projectId: { type: String, default: undefined },
    },
    metaInfo() {
        // if no subcomponents specify a metaInfo.title, this title will be used
        return {
            title: this.project.title,
            titleTemplate: '%s - EDULOC360',
            meta: [
                // Twitter Card
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: this.project.title },
                {
                    name: 'twitter:description',
                    content: this.project.description,
                },
                // image must be an absolute path
                { name: 'twitter:image', content: this.projectBackgroundImage },
                // Facebook OpenGraph
                { property: 'og:title', content: this.project.title },
                { property: 'og:site_name', content: 'EDULOC360' },
                { property: 'og:type', content: 'website' },
                { property: 'og:image', content: this.projectBackgroundImage },
                {
                    property: 'og:description',
                    content: this.project.description,
                },
            ],
        };
    },
    data() {
        return {
            searchValue: '',
            typeFilter: this.$t('Constants.FILTER_OPTION_ALL'),
            searchDropdownOptions: [
                this.$t('Constants.FILTER_OPTION_ALL'),
                this.$t('Constants.FILTER_OPTION_MINE'),
                this.$t('Constants.FILTER_OPTION_MENTIONED'),
                this.$t('Constants.FILTER_OPTION_COMMENTED'),
                this.$t('Constants.FILTER_OPTION_LIKED'),
            ],
            selectedItem: {},
            contentDraft: { owner: {} },
            creationEnabled: false,
            creating: false,
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                        {
                            field: 'description',
                            minlength: 0,
                        },
                        {
                            field: 'tags',
                            minlength: 0,
                        },
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            eventSource: undefined,
            showSettings: false,
            showSessions: false,
            showCreateSessionModal: false,
            showSessionDetailModal: false,
            showMapCreation: false,
            showInputModal: false,
            componentType: undefined,
            fromClipboard: false,
            items: this.$store.getters.projectContent || [],
            logo: process.env.ROOT_PATH + require('@/assets/images/logo.png'),
            showErrorPage: false,
            renderMap: true,
            showingAnswers: false,
            showSimulateSessionModal: false,
            session: {},
            originalItem: {},
            showNotifications: false,

            sessionStarted: false,
            sessionPaused: false,
            startingSession: false,
            editionEnabled: false,
            showThreadList: false,
            showHistory: false,

            configurationChangesWarning: false,
            showSessionActive: false,
            showListSessions: false,
            showSessionDetails: false,

            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,

            pointDraft: undefined,
            mapPositionActive: false,
            showObjectList: false,
            showObjectModal: false,
            activeObject: {},

            objectType: undefined,
            previousObject: undefined,
            selectedObject: "",
            hasDelete: false,
            itemForSimulation: [],
            initialPreviewObject: '',
            pathPreview: {},
            highlightedMarker: undefined,
            selectedObjectMarker: undefined,
            showTreasurehuntSessionPreview: false,

            tileProviders: TILE_PROVIDERS,
            defaultTileProvider: DEFAULT_TILE_PROVIDER,

            showPreviewModal: false,
            objectToPreview: {},
            viewImageModal: false,
            imageToView: "",
            bellowLimit: false,

            showShare: false,

            editingSession: false,

        };
    },
    computed: {
        isMultiLang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
        needWays() {
            return this.mapProvider.needWays;
        },
        mapProvider() {
            if (this.project.mapProvider) {
                return _.findWhere(this.tileProviders, {
                    name: this.project.mapProvider,
                });
            }
            // console.log("defaultProvider",this.defaultTileProvider)
            return this.defaultTileProvider;
        },
        showTreasurehuntHelp() {
            // console.log("showTreasurehuntHelp",this.project.format=="PROJECT_TYPE_TREASUREHUNT" && this.items.length<2 && this.hasCreationPermission)
            return this.project.format == "PROJECT_TYPE_TREASUREHUNT" && this.items.length < 2 && this.hasCreationPermission;
        },
        contentClasses() {
            let classesToAdd = "default-theme";
            if (this.isMobile) {
                classesToAdd = "default-theme-full";
            }
            if (this.hideProjectMenu) {
                classesToAdd += " no-menu"
            }
            return classesToAdd;
        },
        canCreateObjectWithoutLimitations() {
            return this.isAnnonymousParticipation || (!this.isAnonymous && (this.project.accessLevel != 'read' && (!this.sessionStarted || (this.sessionStarted && this.sessionPaused))));
        },
        hideProjectMenu() {
            return !this.canCreateObjectWithoutLimitations && !this.showObjectList && (this.project.format == "PROJECT_TYPE_WALL" || ((this.project.format == "PROJECT_TYPE_QUIZ" || this.project.format == "PROJECT_TYPE_QUIZHUNT" || this.project.format == "PROJECT_TYPE_TREASUREHUNT") && !this.isProjectAdmin));
        },
        hasLocation() {

            return this.project.format == "PROJECT_TYPE_MAP" || this.project.format == "PROJECT_TYPE_GEOQUIZ" || this.objectType == 'clue'
        },
        menuClasses() {
            let classes = "zindex10 lb-project-menu lb-full-height has-scroll-y";
            if (this.isMobile) {
                classes = "tabs is-centered project-menu";
            }
            if (this.embed) {
                classes += " embed-menu";
            }
            return classes;
        },
        isMobile() {
            return this.$mq == "mobile"
        },
        showMenu() {
            //return this.$store.getters['Project/showMenu'];
            return this.creationEnabled || this.editionEnabled || this.showSettings || this.showThreadList || this.showHistory || this.showListSessions || this.showSessionActive || this.showObjectList || this.showShare;
        },
        hasObjects() {
            if (this.$store.getters.projectContent.length) {
                return true;
            }
            return false;
        },
        contentModel() {
            //console.log(this.projectType);
            if (this.objectType) {
                switch (this.objectType) {
                    case 'object':
                        return this.$store.getters.objectModel;
                    case 'question':
                        return this.$store.getters.questionModel;
                    case 'clue':
                        // console.log("clue model")
                        return this.$store.getters.clueGoalModel;
                    case 'card':
                        return this.$store.getters.memoryCardModel;
                }
            } else {
                if (this.projectType === 'trivial' || this.projectType === 'quizhunt') {
                    // console.log(this.$store.getters.questionModel);
                    if (this.project.mode == "map") {
                        return this.$store.getters.geoQuestionModel;
                    } else {
                        return this.$store.getters.questionModel;
                    }

                } else if (this.project.mode == 'map') {
                    return this.$store.getters.markerModel;
                } else if (this.project.format == 'PROJECT_TYPE_MEMORY') {
                    // console.log("In memory project",this.$store.getters.memoryCardModel)
                    return this.$store.getters.memoryCardModel;
                } else {
                    return this.$store.getters.objectModel;
                }
            }

        },
        projectType() {
            return this.$store.getters.project.type;
        },
        isProjectAdmin() {
            return (
                this.$store.getters.isAdmin ||
                this.project.accessLevel == 'administrator'
            );
        },
        objectProjectMaxNumber() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.object.perProjectMaxNumber : 0
        },
        canCreateObject() {
            //console.log("can create object?", this.$store.getters.canCreateObject, (this.isAnnonymousParticipation || (!this.isAnonymous && (this.project.accessLevel != 'read' && (!this.sessionStarted || (this.sessionStarted && this.sessionPaused))))) && (this.$store.getters.canCreateObject && this.$store.getters.projectContent.length<this.objectProjectMaxNumber), this.$store.getters.projectContent.length, this.objectProjectMaxNumber)
            if (this.objectProjectMaxNumber != -1) {

                return (this.isAnnonymousParticipation || (!this.isAnonymous && (this.project.accessLevel != 'read' && (!this.sessionStarted || (this.sessionStarted && this.sessionPaused))))) && (this.$store.getters.canCreateObject && this.userObjectsLength < this.objectProjectMaxNumber);
            } else {
                return (this.isAnnonymousParticipation || (!this.isAnonymous && (this.project.accessLevel != 'read' && (!this.sessionStarted || (this.sessionStarted && this.sessionPaused))))) && this.$store.getters.canCreateObject;
            }
        },
        userObjectsLength() {
            // console.log("total objects", this.$store.getters.projectContent.length)
            let userObjectsCount = 0;
            for (let object of this.$store.getters.projectContent) {
                if (object.owner._id) {
                    // console.log("object owner id", object.owner._id)
                    if (object.owner._id == this.$store.getters.user._id) {
                        userObjectsCount++;
                    }
                } else {
                    // console.log("object owner", object.owner)
                    if (object.owner == this.$store.getters.user._id) {
                        userObjectsCount++;
                    }
                }
            }
            // console.log("total user objects",userObjectsCount)
            return userObjectsCount;

        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        },
        isAnnonymousParticipation() {
            if (this.project.allowAnonymous == true) {
                return this.project.accessLevel != 'read' && this.$store.getters.isAnonymous
            }
            return false;
        },
        canEditObject() {
            return this.editionEnabled && (!this.sessionStarted || (this.sessionStarted && this.sessionPaused));
        },
        isEditionBlocked() {
            return !this.sessionStarted || (this.sessionStarted && this.sessionPaused);
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        project() {
            return this.$store.getters.project;
        },
        itemsSource() {
            return this.$store.getters.projectContent;
        },
        projectBackgroundImage() {
            return this.$store.getters.projectImage || this.logo;
        },
        cardsComponent() {
            return ProjectContent;
        },
        mapComponent() {
            return ProjectContentMapV2;
        },
        treasurehuntComponent() {
            return ProjectContentTreasureHunt;
        },
        getComponent() {
            if (this.project.mode == 'map') {
                return this.mapComponent;
            }
            if (this.project.type == 'treasurehunt') {
                return this.treasurehuntComponent
            }
            return this.cardsComponent;
        },
        simulatePlayComponent() {
            if (this.$store.getters.project.type == 'treasurehunt') {
                return PlayTreasureHunt;
            } else {
                return PlayQuiz;
            }
        },
        filteredItems() {
            let items;
            this.searchIndex.remove(this.items);
            switch (this.typeFilter) {
                case this.$t('Constants.FILTER_OPTION_MINE'):
                    items = this.items.filter((item) => {
                        return (
                            item.owner.owner == this.$store.getters.user.owner
                        );
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_COMMENTED'):
                    items = this.items.filter((item) => {
                        return _.some(item.comments, (comment) => {
                            return (
                                comment.owner.owner ==
                                this.$store.getters.user.owner
                            );
                        });
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_MENTIONED'):
                    items = this.items.filter((item) => {
                        return _.some(item.comments, (comment) => {
                            if (!comment.message) {
                                return false;
                            }
                            return (
                                comment.message.indexOf(
                                    '@' + this.$store.getters.user.username
                                ) > -1
                            );
                        });
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_LIKED'):
                    items = this.items.filter((item) => {
                        return item.liked;
                    });
                    break;
                default:
                    items = this.items;
            }
            if (this.searchValue) {
                this.searchIndex.add(items);
                const result = this.searchIndex.search(this.searchValue);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.items.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            return items;
        },
        hasCreationPermission() {
            return (
                this.$store.getters.isLoggedIn &&
                this.$store.getters.project.accessLevel != 'read'
            );
        },
        hasEditionPermission() {
            return (
                this.$store.getters.isLoggedIn &&
                this.$store.getters.project.accessLevel != 'read' &&
                this.$store.getters.project.accessLevel != 'create'
            );
        },
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        isTrivial() {
            return this.project.type == 'trivial';
        },
        correctAnswers() {
            return _.filter(this.contentDraft.answers, (answer) => {
                if (answer.correct) {
                    return answer && answer.value;
                }
            });
        },
        cleanedAnswers() {
            return _.filter(this.contentDraft.answers, (answer) => {
                if (answer.value) {
                    return answer;
                }
            });
        },
        simulatedSession() {
            let sessionData = {
                configuration: {
                    mode: this.isTrivial != false ? 'TRIVIAL' : 'MAP',
                    time: 2,
                    timeUnits: 'minutes',
                    feedback: '',
                },
                project: this.$store.getters.project,
                title: `Juego de preguntas sobre ${this.$store.getters.project.title}`,
                allowsReset: false,
                session_answers: [],
                simulation: true,
            };
            if (this.$store.getters.project.type == 'treasurehunt') {
                // console.log('treasurehunt sumulation');
                let treasurehuntContent = [];
                let items = [...this.filteredItems];
                for (let item of items) {
                    // console.log(_.keys(item.triggers)[0]);
                    if (_.keys(item.triggers)[0] == 'GO_TO_POINT') {
                        /*console.log(
                            'search point',
                            item.triggers[_.keys(item.triggers)[0]]
                        );*/
                        let pointData = _.findWhere(items, {
                            _id: item.triggers[_.keys(item.triggers)[0]],
                        });
                        // console.log('pointData', pointData);
                        item.location = pointData.location;
                        item.triggers = pointData.triggers;
                        // console.log('item', item);
                        treasurehuntContent.push(item);
                    } else if (
                        _.keys(item.triggers)[0] != 'AT_ARRIVE' &&
                        _.keys(item.triggers)[0] != 'GO_TO_POINT'
                    ) {
                        if (item.triggers[_.keys(item.triggers)[0]] == '') {
                            item.triggers = { END: '' };
                        }
                        treasurehuntContent.push(item);
                    }
                }
                // console.log('treasure hunt content', treasurehuntContent);
                sessionData.context = treasurehuntContent;
            } else {
                sessionData.context = this.filteredItems;
            }
            return sessionData;
        },
        isEmbed() {
            if(this.$route.meta){
                if(this.$route.meta.embed){
                    return true;
                }else{
                    return false;
                }
            }
            return false;
        },
    },
    watch: {
        items: {
            handler: function () {
                this.items.forEach((item) => {
                    this.searchIndex.add(item);
                });
                //this.searchIndex.add(this.items)
            },
            immediate: true,
        },
        itemsSource() {
            this.items = this.itemsSource;
        },
        project: {
            handler: function () {
                if (this.project.activeSession) {
                    // console.log("active session ID",this.project.activeSession)
                    if (!this.session || (this.session._id != this.project.activeSession)) {
                        //console.log("getting session")
                        if (this.isLoggedIn) {
                            this.fetchSession();
                        }
                        /*if ( // desactivat el login anònim
                            !this.isLoggedIn &&
                            (this.project.privacy == 'secret' ||
                                this.project.privacy == 'public') 
                        ) {
                            // console.log('dispatching anonymous login');
                            this.$store
                                .dispatch('anonymousLogin', 'anonymous')
                                .then(() => {
                                    // console.log(this.$store.getters.user);
                                    this.fetchSession();
                                });
                        } else {
                            this.fetchSession();
                        }*/

                    }

                }
            },
            immediate: true,
        },
        session: {
            //deep: true,
            handler: function () {
                // console.log("in session handler")
                if (this.session) {
                    if (!this.session.isArchived) {
                        // console.log("session not archived")
                        if (this.session.isActive) {
                            // console.log("session active")
                            this.sessionStarted = true;
                        } else {
                            this.sessionStarted = false;
                        }
                        if (this.session.isPaused) {
                            // console.log("session paused")
                            this.sessionPaused = true;
                        } else {
                            this.sessionPaused = false;
                        }
                    } else {
                        this.sessionPaused = false;
                        this.sessionStarted = false;
                    }
                }

            },
            immediate: true,
        },
    },
    mounted: function () {
        // console.log("mounted")
        /*setTimeout(() => {
            // this.$Progress.start();
        }, 500);*/
        store
            .dispatch('fetchProject', this.$route.params.projectId)
            .then(() => {
                // console.log("project fetched",this.project)
                const inIframe = window.self !== window.top;
                let canViewInIframe = false;
                if (inIframe) {
                    if (this.project.owner.school && this.project.owner.school.configuration) {
                        canViewInIframe = this.project.owner.school.configuration.project.showEmbed;
                        // console.log('school',this.project.owner.school.configuration.project.showEmbed)
                    } else {
                        canViewInIframe = this.project.owner.plan.configuration.project.showEmbed;
                        // console.log('user', this.project.owner.plan.configuration.project.showEmbed);
                    }
                    if (inIframe && !canViewInIframe) {
                        // console.log("can view in iframe")
                        this.showErrorPage = true;

                    }
                }
        //console.log(this.$router)

                store
                    .dispatch('fetchProjectContent', {
                        _id: this.$route.params.projectId,
                    })
                    .catch(() => {
                        console.error('failed to fetch project content');
                    })
                    .finally(() => {
                        // this.$Progress.finish();
                    });

                /*if ( // desactivat el login anònim
                    !this.isLoggedIn &&
                    (this.project.privacy == 'secret' ||
                        this.project.privacy == 'public') &&
                    this.project.allowAnonymous
                ) {
                    // console.log('dispatching anonymous login');
                    this.$store
                        .dispatch('anonymousLogin', 'anonymous')
                        .then(() => {
                            // console.log(this.$store.getters.user);
                        });
                }*/

                if (!this.project.format) {
                    this.project.format = 'PROJECT_TYPE_WALL';
                    if (this.project.type == 'collection' && !this.project.mode) {
                        this.project.format = 'PROJECT_TYPE_WALL';
                    } else if (this.project.type == 'collection' && this.project.mode == 'map') {
                        this.project.format = 'PROJECT_TYPE_MAP';
                    } else if (this.project.type == 'trivial' && this.project.mode == 'map') {
                        this.project.format = 'PROJECT_TYPE_GEOQUIZ';
                    } else if (this.project.type == 'trivial' && !this.project.mode) {
                        this.project.format = 'PROJECT_TYPE_QUIZ';
                    } else if (this.project.type == 'treasurehunt') {
                        this.project.format = 'PROJECT_TYPE_TREASUREHUNT';
                    } else if (this.project.type == 'storytelling') {
                        this.project.format = 'PROJECT_TYPE_STORYTELLING';
                    } else if (this.project.type == 'timemachine') {
                        this.project.format = 'PROJECT_TYPE_TIMEMACHINE';
                    } else if (this.project.type == 'scape') {
                        this.project.format = 'PROJECT_TYPE_SCAPE';
                    }
                    this.configurationChangesWarning = true;
                }
            })
            .catch((e) => {
                console.error('failed to fetch project', e.status || e);
                this.showErrorPage = true;
            });




        window.addEventListener('paste', this.handlePaste);
        const url = new URL(process.env.VUE_APP_MERCURE_URL);
        url.searchParams.append(
            'topic',
            'http://project.' + this.$route.params.projectId
        );
        this.eventSource = new EventSource(url);
        this.eventSource.onmessage = this.onChangeReceived;
    },
    beforeDestroy() {
        this.eventSource.close();
        window.removeEventListener('paste', this.handlePaste);
    },
    destroyed() {
        this.$store.dispatch('cleanProject');
        if (
            this.$store.getters.isAnonymous &&
            (this.project.privacy == 'secret' ||
                this.project.privacy == 'public') &&
            this.project.allowAnonymous
        ) {
            this.$store.dispatch('logout');
        }
    },

    methods: {
        zoomImage(url){
            this.imageToView=url;
            this.viewImageModal=true;
        },
        closeImageModal(){
            this.imageToView="";
            this.viewImageModal=false;
        },
        closeObjectPreviewModal(){
            this.showPreviewModal = false;
            this.objectToPreview = {};
        },
        showObjectPreview(e){
            // console.log(e)
            this.objectToPreview = e;
            this.showPreviewModal = true;
        },
        highlightMarker(e) {
            // console.log(e)
            this.highlightedMarker = e;
        },
        addTreasurehuntObject(objects) {
            // console.log(objects)
            if (this.creationEnabled) {
                this.disableTreasurehuntCreationEdition();
            }

            this.objectType = objects.type;
            this.contentDraft = objects.newObject;
            this.previousObject = objects.previousObject;
            if (this.isMultiLang) {
                // console.log("content model", this.contentModel)
                if (this.contentModel.titlePerLang) {
                    this.contentDraft.titlePerLang = {};
                }
                if (this.contentModel.descriptionPerLang) {
                    this.contentDraft.descriptionPerLang = {};
                }
                const mediaFiles = _.chain(this.contentModel.media)
                    .pluck('name')
                    .concat()
                    .value();

                mediaFiles.forEach((prop) => { 
                    // console.log(prop)
                    if (prop == 'video') { 
                        this.contentDraft.videoPerLang = {};
                    }
                    if (prop == 'url') { 
                        // console.log("setting url")
                        this.contentDraft.urlPerLang = {};
                    }
                    if (prop == 'files') { 
                        this.contentDraft.filesPerLang = {};
                    }
                    if (prop == 'audio') { 
                        this.contentDraft.audioPerLang = {};
                    }
                });

                if (this.contentModel.related) {
                    // console.log("related", this.contentModel.related)
                    this.contentModel.related.forEach((element) => { 
                        // console.log("checking ",element.name)
                        if (element.name == "answersPerLang") {
                            this.contentDraft.answersPerLang = {}
                        }
                    })
                    
                }
                // console.log(objects.newObject,this.contentDraft)
            }
            if (objects.type == 'clue' && !objects.newObject.location) {
                const model=
                this.contentDraft.location = {};
            }
            this.resetMenu();
            this.creationEnabled = true;
            this.hasDelete = false;
            // console.log("draft",this.contentDraft)
        },
        resetMenu() {
            this.showThreadList = false;
            this.showSettings = false;
            this.showListSessions = false;
            this.showSessionActive = false;
            this.showObjectList = false;
            this.showHistory = false;
            this.showShare = false;
        },
        editTreasurehuntObject(object) {
            // console.log("editing treasurehunt object")
            this.disableTreasurehuntCreationEdition();
            this.resetMenu();
            // console.log('in edition',object);
            this.showObjectModal = false;
            this.creationEnabled = false;
            this.contentDraft = { ...object };
            this.editionEnabled = true;
            this.selectedObject = object._id;

            // console.log("searching parent for", this.contentDraft._id);
            const parent = _.find(this.items, (item) => {
                return _.find(item.triggers, (trigger) => {
                    return trigger == this.contentDraft._id;
                });
            });
            if (parent) {
                // console.log("enable deletion");
                this.hasDelete = true;
                // this.previousObject = parent;
            }

            this.objectType = object.type;
            if(this.objectType=='clue'){
                this.selectedObjectMarker = object._id;
                this.activeObject = object;
                this.pointDraft = {
                    location: {
                        latitude: object.location.latitude,
                        longitude: object.location.longitude,
                    },
                };
            }else{
                this.selectedObjectMarker = "";
            }

            if (this.isMultiLang) {
                // console.log("content model", this.contentModel)
                if (this.contentModel.titlePerLang && !this.contentDraft.titlePerLang) {
                    this.contentDraft.titlePerLang = {};
                    // console.log(this.$store.getters.project.defaultLang)
                    if (this.$store.getters.project.defaultLang) {
                        this.contentDraft.titlePerLang[this.$store.getters.project.defaultLang] = this.contentDraft.title;
                        // console.log(this.contentDraft.titlePerLang[this.$store.getters.project.defaultLang])
                    }
                    
                }
                if (this.contentModel.descriptionPerLang && !this.contentDraft.descriptionPerLang) {
                    this.contentDraft.descriptionPerLang = {};
                    if (this.$store.getters.project.defaultLang) {
                        this.contentDraft.descriptionPerLang[this.$store.getters.project.defaultLang] = this.contentDraft.description;
                    }
                }
                const mediaFiles = _.chain(this.contentModel.media)
                    .pluck('name')
                    .concat()
                    .value();

                mediaFiles.forEach((prop) => { 
                    // console.log(prop)
                    if (prop == 'video' && !this.contentDraft.videoPerLang) { 
                        this.contentDraft.videoPerLang = {};
                    }
                    if (prop == 'url' && !this.contentDraft.urlPerLang) { 
                        // console.log("setting url")
                        this.contentDraft.urlPerLang = {};
                    }
                    if (prop == 'files' && !this.contentDraft.filesPerLang) { 
                        this.contentDraft.filesPerLang = {};
                    }
                    if (prop == 'audio' && !this.contentDraft.audioPerLang) { 
                        this.contentDraft.audioPerLang = {};
                    }
                });

                if (this.contentModel.related) {
                    // console.log("related", this.contentModel.related)
                    this.contentModel.related.forEach((element) => { 
                        // console.log("checking ",element.name)
                        if (element.name == "answersPerLang" && !this.contentDraft.answersPerLang) {
                            this.contentDraft.answersPerLang = {}
                        }
                    })
                    
                }
                // console.log(objects.newObject,this.contentDraft)
            }
        },
        disableTreasurehuntCreationEdition() {
            console.log("disable treasurehunt creation/edition")
            if (!this.editionEnabled) {
                const parent = _.find(this.items, (item) => {
                    return _.find(item.triggers, (trigger) => {
                        return trigger == this.contentDraft._id;
                    });
                });
                if (parent) {
                    const parentTrigger = _.keys(parent.triggers)[0];
                    const draftTrigger = _.keys(this.contentDraft.triggers)[0];
                    parent.triggers[parentTrigger] =
                        this.contentDraft.triggers[draftTrigger];
                }

                this.$store.commit(
                    'REMOVE_OBJECT_FROM_PROJECT',
                    this.contentDraft._id
                );
            }
            this.contentDraft = { owner: {}, location: {} };
            this.previousObject = undefined;
            this.objectType = undefined;
            this.showCreation = false;
            this.creationEnabled = false;
            this.editionEnabled = false;
            this.hasDelete = false;
            this.selectedObject = "";

            this.highlightedMarker = undefined;
            this.selectedObjectMarker = undefined;

            this.originalItem = {};
            this.pointDraft = undefined;
            this.mapPositionActive = false;
            this.activeObject = {};

        },
        addPoint(pointData) {
            // console.log("adding point",typeof(pointData.lat))
            if(typeof pointData.lat === 'string'){
                this.contentDraft.location = {
                    latitude: parseFloat(pointData.lat),
                    longitude: parseFloat(pointData.lon),
                };
                // console.log("transform to float")
            }else{
                this.contentDraft.location = {
                    latitude: pointData.lat,
                    longitude: pointData.lon,
                };
            }
            
            this.pointDraft = {
                location: { latitude: pointData.lat, longitude: pointData.lon },
            };
            // console.log(this.pointDraft)
        },
        updateDraftPosition(position) {
            this.pointDraft = position
            this.contentDraft.location = position.location
        },
        enableCreation() {
            // console.log("from enable creation")
            this.toggleCreation();
        },
        addObject() {
            // console.log("adding object",this.contentModel)
            this.contentDraft._id = 'draft';
            this.contentDraft.order = this.items.length + 1;
            this.contentDraft.owner = this.$store.getters.user;
            if (this.project.format == "PROJECT_TYPE_MAP" || this.project.format == "PROJECT_TYPE_GEOQUIZ") {
                this.contentDraft.location = {};
            }
            if (this.project.format == "PROJECT_TYPE_GEOQUIZ") {
                this.contentDraft.location = {};
                this.contentDraft.questions = [{}];

            }
            if (this.project.format == "PROJECT_TYPE_MEMORY") {
                this.contentDraft.pairWith = {};
            }
            if (this.contentModel.title) {
                this.contentDraft.titlePerLang = {};
                /*if (this.project.langs) {
                    this.project.langs.forEach((langCode) => {
                        //console.log(langCode)
                        this.contentDraft.titlePerLang
                    })
                }*/
            }
            if (this.contentModel.description) {
                this.contentDraft.descriptionPerLang = {};
            }

            const mediaFiles = _.chain(this.contentModel.media)
                .pluck('name')
                .concat()
                .value();

            mediaFiles.forEach((prop) => { 
                // console.log(prop)
                if (prop == 'video') { 
                    this.contentDraft.videoPerLang = {};
                }
                if (prop == 'url') { 
                    // console.log("setting url")
                    this.contentDraft.urlPerLang = {};
                }
                if (prop == 'files') { 
                    this.contentDraft.filesPerLang = {};
                }
                if (prop == 'audio') { 
                    this.contentDraft.audioPerLang = {};
                }
            });

            if (this.contentModel.related) {
                // console.log("related", this.contentModel.related)
                this.contentModel.related.forEach((element) => { 
                    // console.log("checking ",element.name)
                    if (element.name == "answersPerLang") {
                        this.contentDraft.answersPerLang = {}
                    }
                })
                
            }
            // console.log("content model",this.contentDraft)


            this.creationEnabled = true;
        },
        toggleCreation() {
            if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput().then(() => {
                            this.addObject();
                        });
                    }
                });
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.addObject();
            } else if (this.showHistory) {
                this.showHistory = false;
                this.addObject();
            } else if (this.showSettings) {
                this.showSettings = false;
                this.addObject();
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.addObject();
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.addObject();
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.addObject();
            } else if(this.showShare){
                this.showShare = false;
                this.addObject(item);
            }else if (this.creationEnabled) {
                return;
            } else {
                this.addObject();
            }
        },
        toggleEdition(item) {
            if (this.creationEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.editObject(item);
                    }
                });
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.editObject(item);
            } else if (this.showHistory) {
                this.showHistory = false;
                this.editObject(item);
            } else if (this.showSettings) {
                this.showSettings = false;
                this.editObject(item);
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.editObject(item);
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.editObject(item);
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.editObject(item);
            } else if(this.showShare){
                this.showShare = false;
                this.editObject(item);
            }else if (this.editionEnabled) {
                return;
            } else {
                this.editObject(item);
            }
        },
        toggleSettings() {
            // this.creationEnabled || this.editionEnabled || this.showSettings || this.showThreadList || this.showHistory
            if (this.creationEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showSettings = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showSettings = true;
                    }
                });
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.showSettings = true;
            } else if (this.showHistory) {
                this.showHistory = false;
                this.showSettings = true;
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.showSettings = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.showSettings = true;
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.showSettings = true;
            } else if(this.showShare){
                this.showShare = false;
                this.showSettings = true;
            }else if (this.showSettings) {
                this.showSettings = false;
            } else {
                this.showSettings = true;
            }
        },
        toggleObjectList() {
            // this.creationEnabled || this.editionEnabled || this.showSettings || this.showThreadList || this.showHistory
            if (this.creationEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showObjectList = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showObjectList = true;
                    }
                });
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.showObjectList = true;
            } else if (this.showHistory) {
                this.showHistory = false;
                this.showObjectList = true;
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.showObjectList = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.showObjectList = true;
            } else if (this.showSettings) {
                this.showSettings = false;
                this.showObjectList = true;
            } else if(this.showShare){
                this.showShare = false;
                this.showObjectList = true;
            }else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
            } else {
                this.showObjectList = true;
            }
        },
        toggleThreadList() {
            // this.creationEnabled || this.editionEnabled || this.showSettings || this.showThreadList || this.showHistory
            if (this.creationEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showThreadList = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showThreadList = true;
                    }
                });
            } else if (this.showSettings) {
                this.showSettings = false;
                this.showThreadList = true;
            } else if (this.showHistory) {
                this.showHistory = false;
                this.showThreadList = true;
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.showThreadList = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.showThreadList = true;
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.showThreadList = true;
            } else if(this.showShare){
                this.showShare = false;
                this.showThreadList = true;
            }else if (this.showThreadList) {
                this.showThreadList = false;
            } else {
                this.showThreadList = true;
            }
        },
        toggleHistory() {
            // this.creationEnabled || this.editionEnabled || this.showSettings || this.showThreadList || this.showHistory
            if (this.creationEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showHistory = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showHistory = true;
                    }
                });
            } else if (this.showSettings) {
                this.showSettings = false;
                this.showHistory = true;
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.showHistory = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.showHistory = true;
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.showHistory = true;
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.showHistory = true;
            } else if(this.showShare){
                this.showShare = false;
                this.showHistory = true;
            }else if (this.showHistory) {
                this.showHistory = false;
            } else {
                this.showHistory = true;
            }
        },
        toggleListSessions() {
            if (this.creationEnabled) {
                Swal.fire({
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showSessions = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showListSessions = true;
                    }
                });
            } else if (this.showSettings) {
                this.showSettings = false;
                this.showListSessions = true;
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.showListSessions = true;
            } else if (this.showHistory) {
                this.showHistory = false;
                this.showListSessions = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.showListSessions = true;
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.showListSessions = true;
            } else if(this.showShare){
                this.showShare = false;
                this.showListSessions = true;
            }else if (this.showListSessions) {
                this.showListSessions = false;
            } else {
                this.showListSessions = true;
            }
        },
        toggleSessionActive() {
            if (this.creationEnabled) {
                Swal.fire({
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showSessionActive = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showSessionActive = true;
                    }
                });
            } else if (this.showSettings) {
                this.showSettings = false;
                this.showSessionActive = true;
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.showSessionActive = true;
            } else if (this.showHistory) {
                this.showHistory = false;
                this.showSessionActive = true;
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.showSessionActive = true;
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.showSessionActive = true;
            } else if(this.showShare){
                this.showShare = false;
                this.showSessionActive = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
            } else {
                this.showSessionActive = true;
            }
        },
        toggleShare() {
            // console.log("in toggleShare")
            if (this.creationEnabled) {
                Swal.fire({
                    text: this.$t('creation_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showShare = true;
                    }
                });
            } else if (this.editionEnabled) {
                Swal.fire({
                    //title: this.$t('delete_object_title'),
                    text: this.$t('edition_object_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelInput();
                        this.showShare = true;
                    }
                });
            } else if (this.showSettings) {
                this.showSettings = false;
                this.showShare = true;
            } else if (this.showThreadList) {
                this.showThreadList = false;
                this.showShare = true;
            } else if (this.showHistory) {
                this.showHistory = false;
                this.showShare = true;
            } else if (this.showListSessions) {
                this.showListSessions = false;
                this.showShare = true;
            } else if (this.showObjectList) {
                this.searchValue = '';
                this.filteredItems;
                this.showObjectList = false;
                this.showShare = true;
            } else if (this.showSessionActive) {
                this.showSessionActive = false;
                this.showShare = true;
            } else if(this.showShare){
                this.showShare = false;
            } else {
                // console.log("showing share")
                this.showShare = true;
            }
        },
        updateOrCreateObject() {
            if (this.contentDraft._id != 'draft') {
                this.updateObject();
            } else {
                this.createObject();
            }
        },
        updateOrCreateMemoryObject() {
            if (this.contentDraft._id != 'draft') {
                //this.updateMemoryObject();
                this.updateObject();
            } else {
                this.createMemoryObject();
            }
        },
        async createObject() {
            //console.log("sending new object")
            if (!isEmptyObject(_.omit(this.contentDraft, '_id', 'order', 'owner'))) {
                if (this.creating == true) {
                    return this.cancelInput();
                }

                /*if (this.project.type === 'trivial' || this.objectType == 'question') {
                    const responseValidator = this.questionValidator();
                    if (responseValidator !== 'ALL_OK') {
                        alert(this.$t(responseValidator));
                        return;
                    }
                }*/
                this.creating = true;
                if (this.project.type === 'treasurehunt') {
                    if (this.items.length <= 1) {
                        this.contentDraft.order = 1;
                    }
                    if (this.previousObject) {
                        this.contentDraft.order = this.previousObject.order + 1;
                    }

                    let contentToSend = { ...this.contentDraft };

                    if (this.isMultiLang) {
                        if (contentToSend.descriptionPerLang && _.isEmpty(contentToSend.descriptionPerLang)) {
                            // console.log("eliminant descriptionperlang")
                            delete contentToSend.descriptionPerLang;
                        }  
                        if (contentToSend.videoPerLang && _.isEmpty(contentToSend.videoPerLang)) {
                            // console.log("eliminant videoperlang")
                            delete contentToSend.videoPerLang;
                        }
                        if (contentToSend.urlPerLang && _.isEmpty(contentToSend.urlPerLang)) {
                            // console.log("eliminant urlperlang")
                            delete contentToSend.urlPerLang;
                        }
                        if (contentToSend.audioPerLang && _.isEmpty(contentToSend.audioPerLang)) {
                            // console.log("eliminant audioperlang")
                            delete contentToSend.audioPerLang;
                        }
                        if (contentToSend.filesPerLang && _.isEmpty(contentToSend.filesPerLang)) {
                            // console.log("eliminant filesperlang")
                            delete contentToSend.filesPerLang;
                        }
                    }

                    let createdObject = await this.$store
                        .dispatch('createObject', {
                            ...contentToSend,
                            ...{ project: this.$route.params.projectId },
                        })
                        .catch((e) => {
                            console.error('error creatiorn', e);
                            this.creating = false;
                        });

                    if (this.previousObject) {
                        this.previousObject.triggers[_.keys(this.previousObject.triggers)[0]] = createdObject._id;
                        let editedObject = await this.$store.dispatch('updateObject', {
                            ...this.previousObject,
                        });
                        const objectIndex = _.findIndex(this.items, {
                            _id: editedObject._id,
                        });
                        this.items.splice(objectIndex, 1, editedObject);
                    }
                    this.$store.commit(
                        'REMOVE_OBJECT_FROM_PROJECT',
                        this.contentDraft._id
                    );

                    this.contentDraft = { owner: {}, location: {} };
                    this.previousObject = undefined;
                    this.objectType = undefined;
                    this.showCreation = false;
                    this.creationEnabled = false;
                    this.editionEnabled = false;
                    this.hasDelete = false;
                    this.selectedObject = "";

                    this.originalItem = {};
                    this.pointDraft = undefined;
                    this.mapPositionActive = false;
                    this.activeObject = {};
                    this.creating = false;


                    // this.highlightedMarker = undefined;
                    // this.selectedObjectMarker = undefined;


                    // console.log("treasurehunt object created")
                    // this.disableTreasurehuntCreationEdition();

                } else {
                    if (this.items.length > 1) {
                        this.contentDraft.order = this.items.length;
                    } else {
                        this.contentDraft.order = 1;
                    }

                    let contentToSend = { ...this.contentDraft };

                    if (this.isMultiLang) {
                        if (contentToSend.descriptionPerLang && _.isEmpty(contentToSend.descriptionPerLang)) {
                            // console.log("eliminant descriptionperlang")
                            delete contentToSend.descriptionPerLang;
                        }  
                        if (contentToSend.videoPerLang && _.isEmpty(contentToSend.videoPerLang)) {
                            // console.log("eliminant videoperlang")
                            delete contentToSend.videoPerLang;
                        }
                        if (contentToSend.urlPerLang && _.isEmpty(contentToSend.urlPerLang)) {
                            // console.log("eliminant urlperlang")
                            delete contentToSend.urlPerLang;
                        }
                        if (contentToSend.audioPerLang && _.isEmpty(contentToSend.audioPerLang)) {
                            // console.log("eliminant audioperlang")
                            delete contentToSend.audioPerLang;
                        }
                        if (contentToSend.filesPerLang && _.isEmpty(contentToSend.filesPerLang)) {
                            // console.log("eliminant filesperlang")
                            delete contentToSend.filesPerLang;
                        }
                        if (contentToSend.answersPerLang && !_.isEmpty(contentToSend.answersPerLang)) {
                            if (contentToSend.answersPerLang[this.$store.getters.project.defaultLang]) {
                                contentToSend.answers = contentToSend.answersPerLang[this.$store.getters.project.defaultLang];
                            }
                        }
                    }

                    // console.log("guardant", this.contentDraft)
                    
                    await this.$store
                        .dispatch('createObject', {
                            ...contentToSend,
                            ...{ project: this.$route.params.projectId },
                        })
                        .catch((e) => {
                            console.error('error creatiorn', e);
                            this.creating = false;
                        });

                    this.creating = false;
                    this.showCreation = false;
                    this.items = this.$store.getters.projectContent.filter(
                        function (item) {
                            return item['_id'] != 'draft';
                        }
                    );

                    this.creationEnabled = false;
                    this.contentDraft = { owner: {} };
                    if (this.pointDraft) {
                        this.pointDraft = undefined;
                    }

                    this.creating = false;
                    this.showCreation = false;
                    this.previousObject = undefined;
                    this.objectType = undefined;
                    this.selectedObject = "";
                }
            } else {
                // console.log("empty object")
                this.cancelInput();
            }

        },
        async createMemoryObject() {
            // console.log("sending new memory object",this.contentDraft)
            if (!isEmptyObject(_.omit(this.contentDraft, '_id', 'order', 'owner'))) {
                if (this.creating == true) {
                    return this.cancelInput();
                }
                
                this.creating = true;
                //let pairWith = this.contentDraft.pairWith;
                //let object = _.omit(this.contentDraft, '_id', 'order', 'owner','pairWith')
                
                if (this.items.length > 1) {
                    this.contentDraft.order = this.items.length;
                    // console.log("items length",this.items.length)
                    this.contentDraft.pairWith.order = (this.items.length*2)+1;
                } else {
                    this.contentDraft.order = 1;
                    this.contentDraft.pairWith.order = 2;
                }

                await this.$store
                    .dispatch('createObject', {
                        ...this.contentDraft,
                        ...{ project: this.$route.params.projectId },
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        this.creating = false;
                    });
                
            } else {
                // console.log("empty object")
                this.cancelInput();
            }

            // console.log(this.items)
            this.creating = false;
                this.showCreation = false;
                this.items = this.$store.getters.projectContent.filter(
                    function (item) {
                        return item['_id'] != 'draft';
                    }
                );

                this.creationEnabled = false;
                this.contentDraft = { owner: {} };
                if (this.pointDraft) {
                    this.pointDraft = undefined;
                }

                this.creating = false;
                this.showCreation = false;
                this.previousObject = undefined;
                this.objectType = undefined;
                this.selectedObject = "";

        },
       
        editObject(item) {
            this.contentDraft = item;

            if (this.isMultiLang) {
                const mediaFiles = _.chain(this.contentModel.media)
                    .pluck('name')
                    .concat()
                    .value();

                mediaFiles.forEach((prop) => { 
                    // console.log(prop)
                    if (prop == 'video' && !this.contentDraft.videoPerLang) { 
                        this.contentDraft.videoPerLang = {};
                    }
                    if (prop == 'url' && !this.contentDraft.urlPerLang) { 
                        // console.log("setting url")
                        this.contentDraft.urlPerLang = {};
                    }
                    if (prop == 'files' && !this.contentDraft.filesPerLang) { 
                        this.contentDraft.filesPerLang = {};
                    }
                    if (prop == 'audio' && !this.contentDraft.audioPerLang) { 
                        this.contentDraft.audioPerLang = {};
                    }
                });

                if (this.contentModel.description) {
                    if (!this.contentDraft.descriptionPerLang) {
                        this.contentDraft.descriptionPerLang = {};
                    }  
                }
                if (this.contentModel.title) {
                    if (!this.contentDraft.titlePerLang) {
                        this.contentDraft.titlePerLang = {};
                    }  
                }
                
            }
            

            this.editionEnabled = true;
            // this.creationEnabled = true;
            this.originalItem = JSON.parse(JSON.stringify(item));
        },
        async updateObject() {
            /*if (this.project.type === 'trivial' || this.objectType == 'question') {
                const responseValidator = this.questionValidator();
                if (responseValidator !== 'ALL_OK') {
                    alert(this.$t(responseValidator));
                    return;
                }
            }*/
            if (this.project.type === 'treasurehunt') {

                let contentToSend = { ...this.contentDraft };

                if (this.isMultiLang) {
                    if (contentToSend.descriptionPerLang && _.isEmpty(contentToSend.descriptionPerLang)) {
                        // console.log("eliminant descriptionperlang")
                        delete contentToSend.descriptionPerLang;
                    }  
                    if (contentToSend.videoPerLang && _.isEmpty(contentToSend.videoPerLang)) {
                        // console.log("eliminant videoperlang")
                        delete contentToSend.videoPerLang;
                    }
                    if (contentToSend.urlPerLang && _.isEmpty(contentToSend.urlPerLang)) {
                        // console.log("eliminant urlperlang")
                        delete contentToSend.urlPerLang;
                    }
                    if (contentToSend.audioPerLang && _.isEmpty(contentToSend.audioPerLang)) {
                        // console.log("eliminant audioperlang")
                        delete contentToSend.audioPerLang;
                    }
                    if (contentToSend.filesPerLang && _.isEmpty(contentToSend.filesPerLang)) {
                        // console.log("eliminant filesperlang")
                        delete contentToSend.filesPerLang;
                    }
                }

                let editedObject = await this.$store.dispatch('updateObject', {
                    ...contentToSend,
                });
                if (editedObject) {
                    // console.log(editedObject);
                    const objectIndex = _.findIndex(this.items, {
                        _id: editedObject._id,
                    });
                    this.items.splice(objectIndex, 1, editedObject);
                    this.editionEnabled = false;
                    this.pointDraft = undefined;
                    this.contentDraft = { owner: {}, location: {} };
                    this.activeObject = undefined;
                    this.previousObject = undefined;
                    this.objectType = undefined;
                    this.hasDelete = false;
                    this.selectedObject = undefined;
                    this.highlightedMarker = undefined;
                    this.selectedObjectMarker = undefined;
                }
            } else {

                let contentToSend = { ...this.contentDraft };

                if (this.isMultiLang) {
                    if (contentToSend.descriptionPerLang && _.isEmpty(contentToSend.descriptionPerLang)) {
                        // console.log("eliminant descriptionperlang")
                        delete contentToSend.descriptionPerLang;
                    }  
                    if (contentToSend.videoPerLang && _.isEmpty(contentToSend.videoPerLang)) {
                        // console.log("eliminant videoperlang")
                        delete contentToSend.videoPerLang;
                    }
                    if (contentToSend.urlPerLang && _.isEmpty(contentToSend.urlPerLang)) {
                        // console.log("eliminant urlperlang")
                        delete contentToSend.urlPerLang;
                    }
                    if (contentToSend.audioPerLang && _.isEmpty(contentToSend.audioPerLang)) {
                        // console.log("eliminant audioperlang")
                        delete contentToSend.audioPerLang;
                    }
                    if (contentToSend.filesPerLang && _.isEmpty(contentToSend.filesPerLang)) {
                        // console.log("eliminant filesperlang")
                        delete contentToSend.filesPerLang;
                    }
                    if (contentToSend.answersPerLang && !_.isEmpty(contentToSend.answersPerLang)) {
                        if (contentToSend.answersPerLang[this.$store.getters.project.defaultLang]) {
                            // console.log("assignant resposta per defecte")
                            contentToSend.answers = contentToSend.answersPerLang[this.$store.getters.project.defaultLang];
                        }
                    }
                }

                await this.$store.dispatch('updateObject', {
                    ...contentToSend,
                });
                this.editionEnabled = false;
                this.contentDraft = { owner: {} };
                if (this.pointDraft) {
                    this.pointDraft = undefined;
                }
                if (this.activeObject) {
                    this.activeObject = {};
                }
            }
        },
        cancelInput() {
            // console.log("in cancel input")
            if (this.project.format == "PROJECT_TYPE_TREASUREHUNT") {
                this.disableTreasurehuntCreationEdition();
            } else {
                if (this.contentDraft._id == 'draft') {
                    // console.log(this.items)
                    //this.items = _.without(this.items, this.contentDraft);
                    const objectIndex = _.findIndex(this.items, {
                        _id: this.contentDraft._id,
                    });
                    // console.log("objectIndex",objectIndex)
                    if(objectIndex!=-1){
                        // console.log("removing")
                        this.items.splice(objectIndex, 1);
                    }
                    
                } else {
                    const objectIndex = _.findIndex(this.items, {
                        _id: this.contentDraft._id,
                    });
                    this.items.splice(objectIndex, 1, this.originalItem);
                }
                this.contentDraft = { owner: {} };
                this.originalItem = {};
                this.showCreation = false;
                this.creationEnabled = false;
                this.editionEnabled = false;
                this.pointDraft = undefined;
                this.mapPositionActive = false;
                this.activeObject = {};
            }
        },
        updateProject(projectData) {
            // console.log("updating settings",projectData);
            this.$store
                .dispatch('updateProject', {
                    id: this.project._id,
                    project: projectData,
                })
                .then(() => {
                    this.showSettings = false;
                    this.showShare = false;
                })
                .catch((e) => {
                    //show error
                    console.error(e);
                });
        },
        startSession() {
            // console.log("in start session")
            // this.sessionStarted = true;
            if (this.items.length) {
                this.startingSession = true;
            } else {
                // console.log("no items")
                Swal.fire({
                    text: this.$t('game_session_no_objects'),
                    confirmButtonText: this.$t('Buttons.return'),
                })
                return;
            }

        },
        pauseSession() {
            // console.log("pause session")
            pauseSession(this.session._id, this.session).then((res) => {
                this.fetchSession();
            });


        },
        continueSession() {
            // console.log("continue session")
            if (this.editionEnabled || this.creationEnabled) {
                return;
            }
            if (this.items.length) {

                if (this.session.project.type == 'memory') {
                    // console.log("continue memory session",this.session.configuration.gameZone,(this.items.length * 2),this.session.context.length)
                    if ( ( (this.items.length * 2) != this.session.context.length) && this.session.configuration.gameZone.coordinates) {
                        Swal.fire({
                            text: this.$t('game_memory_change_objects'),
                            confirmButtonText: this.$t('Buttons.return'),
                        })
                        if (!this.showSessionActive) {
                            this.toggleSessionActive();
                        }
                        return;
                    }
                }
                continueSession(this.session._id, this.session).then((res) => {
                    this.fetchSession();
                });
            } else {
                // console.log("no items")
                Swal.fire({
                    text: this.$t('game_session_no_objects'),
                    confirmButtonText: this.$t('Buttons.return'),
                })
                return;
            }

        },
        stopSession() {
            // console.log("stop session");
            Swal.fire({
                //title: this.$t('delete_object_title'),
                html: this.$t('game_session_stop_warning'),
                showCancelButton: true,
                confirmButtonText: this.$t('stop_session'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    stopSession(this.session._id, this.session).then((res) => {
                        // this.fetchSession();
                        this.sessionStarted = false;
                        this.sessionPaused = false;
                        this.session = {};
                        this.$store.dispatch('cleanSession');
                        this.showSessionActive = false;
                    });
                }
            });



        },
        activateSession() {
            this.sessionStarted = true;
            this.session = this.$store.getters.session;
            this.toggleSessionActive();
            // this.showSessionDetails = true;
            //this.fetchSession();
        },
        async fetchSession() {
            // console.log("fetch session data")
            let sessionData = await fetchItem(
                'session',
                this.project.activeSession
            );
            this.$store.dispatch('setSession', sessionData.data);
            this.session = sessionData.data;
            // console.log("session data",sessionData.data,this.session)
        },
        questionValidator() {
            if (!this.contentDraft.title) {
                return 'Object.errors.FILL_QUESTION';
            }
            if (
                this.contentDraft.answerType == 'HANGMAN' ||
                this.contentDraft.answerType == 'FREETEXT'
            ) {
                if (!this.contentDraft.answers) {
                    return 'Object.errors.FILL_ANSWER';
                }
                if (this.correctAnswers.length) {
                    this.cleanAnswers(); // removes emtpy answers
                    this.contentDraft.answers = [this.correctAnswers[0]]; // ensure only one answer for this question type
                } else {
                    return 'Object.errors.MARK_CORRECT';
                }
            } else {
                if (
                    !this.contentDraft.answers ||
                    !this.contentDraft.answers.length
                ) {
                    return 'Object.errors.FILL_ANSWERS';
                }
                this.cleanAnswers(); // removes emtpy answers
                if (this.correctAnswers.length < 1) {
                    return 'Object.errors.MARK_CORRECT';
                }
            }
            return 'ALL_OK';
        },
        cleanAnswers() {
            this.contentDraft.answers = this.cleanedAnswers;
        },
        searchObjects(text) {
            this.searchValue = text;
            this.filteredItems;
        },
        startSimulation() {
            // console.log('in start simulation');
            this.$store
                .dispatch('setSession', this.simulatedSession)
                .catch((e) => {
                    console.log('error setting simulation session');
                });
            this.showSimulateSessionModal = true;
        },
        onChangeReceived(e) {
            const data = JSON.parse(e.data);
            switch (data.type) {
                case 'UPDATE':
                case 'NEW_COMMENT':
                    this.$store.commit('UPDATE_OBJECT', data.object);
                    break;
                case 'CREATE':
                    this.$store.commit('ADD_OBJECT_TO_PROJECT', data.object);
                    break;
                case 'NEW_PROJECT_COMMENT':
                    this.$store.commit('ADD_COMMENT_TO_PROJECT', data.object);
                    break;
                case 'PROJECT_COMMENT_UPDATED':
                    this.$store.commit('UPDATE_COMMENT_TO_PROJECT', data.object);
                    break;
                case 'LIKE_PROJECT_COMMENT':
                    this.$store.commit('UPDATE_COMMENT', {
                        _id: data.object._id,
                        comment: data.object,
                    });
                    break;
                case 'NEW_PROJECT_CHANGE':
                    this.$store.commit('ADD_CHANGE_TO_PROJECT', data.object);
                    break;
                case 'DELETE_OBJECT':
                    this.$store.commit('DELETE_OBJECT', data.object);
                    break;
                case 'NEW_ACTIVE_SESSION':
                    this.$store.commit('ADD_ACTIVE_SESSION_TO_PROJECT', data.object);
                    if (this.project.activeSession && !this.session.length) {
                        this.fetchSession();
                    }
                    break;
                case 'PAUSE_ACTIVE_SESSION':
                    if (this.session && !this.session.isPaused) {
                        this.fetchSession();
                    }
                    break;
                case 'CONTINUE_ACTIVE_SESSION':
                    if (this.session && this.session.isPaused) {
                        this.fetchSession();
                    }

                    break;
                case 'REMOVE_ACTIVE_SESSION':
                    this.$store.commit('REMOVE_ACTIVE_SESSION_TO_PROJECT');
                    if (this.session) {
                        this.session = {};
                        this.$store.dispatch('cleanSession');
                    }

                    break;
                case 'REMOVED_PROJECT':
                    Swal.fire({
                        title: this.$t('deleted_project_title'),
                        text: this.$t('delete_project_message',{ username: data.user, project: data.object.title }),
                        showCancelButton: false,
                        confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    }).then(() => {
                        this.$router.push("/dashboard?filter=mine");
                    });
                    break;
                default:
                    console.log('unhandled event ', data.type || data.message);
            }
        },
        handlePaste(e) {
            this.$store.dispatch('setClipboardContent', e.clipboardData.items);
        },

        async deleteObject(object) {
            // console.log('try to remove object', object);
            if (this.project.type == 'treasurehunt' || this.project.format == "PROJECT_TYPE_TREASUREHUNT") {
                this.deleteTreasurehuntObject(object);
            } else {

                if (!object._id || object._id == 'draft') {
                    return this.cancelInput();
                } else {

                    Swal.fire({
                        title: this.$t('delete_object_title'),
                        text: this.$t('delete_object_confirmation_message'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('userProfile.leave_school_continue'),
                        cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$store.dispatch('deleteObject', object._id);
                            this.items = this.$store.getters.projectContent.filter(
                                function (item) {
                                    return item['_id'] != 'draft' && item['_id'] != object._id;
                                }
                            );
                            this.cancelInput();
                        }
                    });



                }
            }
        },

        openConfiguration() {
            this.configurationChangesWarning = false;
            this.toggleSettings();
        },
        showObject(object) {
            this.activeObject = object;
            this.showObjectModal = true;
        },
        closeObjectModal() {
            this.showObjectModal = false;
            this.activeObject = {};
        },
        editObjectInit() {
            // console.log("editing object")
            this.toggleEdition(this.activeObject);
            this.pointDraft = {
                location: {
                    latitude: this.activeObject.location.latitude,
                    longitude: this.activeObject.location.longitude,
                },
            };
            this.showObjectModal = false;
        },
        centerMap(object) {
            this.$refs.content.$refs.editMap.fitBounds(
                L.latLngBounds([[object.location.latitude, object.location.longitude]]), { 'maxZoom': 19 }
            );
            this.showObject(object);
        },
        showTreasurehuntPreview(data) {
            // console.log(data.pathPreview)
            let treasurehuntContent = {};
            for (let item in data.pathPreview) {
                if (_.keys(data.pathPreview[item].triggers)[0] == 'GO_TO_POINT') {
                    let pointData = data.pathPreview[data.pathPreview[item].triggers.GO_TO_POINT];
                    data.pathPreview[item].location = pointData.location;
                    data.pathPreview[item].triggers = pointData.triggers;
                    treasurehuntContent[item] = data.pathPreview[item]
                } else if (
                    _.keys(data.pathPreview[item].triggers)[0] != 'AT_ARRIVE' &&
                    _.keys(data.pathPreview[item].triggers)[0] != 'GO_TO_POINT'
                ) {
                    if (data.pathPreview[item].triggers[_.keys(item.triggers)[0]] == '') {
                        data.pathPreview[item].triggers = { END: '' };
                    }
                    treasurehuntContent[item] = data.pathPreview[item]
                }
            }
            this.pathPreview = treasurehuntContent;
            this.initialPreviewObject = data.initialPreviewObject;
            this.showTreasurehuntSessionPreview = true;

        },
        hideTreasurehuntPreview() {
            this.showTreasurehuntSessionPreview = false;
            this.pathPreview = {};
            this.initialPreviewObject = '';
        },

        deleteTreasurehuntObject(object) {
            // console.log('try to remove object', object);
            const parent = _.find(this.items, (item) => {
                return _.find(item.triggers, (trigger) => {
                    return trigger == object._id;
                });
            });
            if (!parent) {
                // alert(this.$t('delete_first_object_forbidden'));
                Swal.fire({
                    text: this.$t('delete_first_object_forbidden'),
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                })
                return;
            }
            if (!object._id || object._id == 'draft') {
                this.$store.dispatch('Project/disableCreation');
                this.removeDraft();
            } else {

                Swal.fire({
                    title: this.$t('delete_object_title'),
                    text: this.$t('delete_object_confirmation_message'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    cancelButtonText: this.$t('userProfile.leave_school_cancel'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (parent) {
                            this.removeObject(parent, object);
                        }
                    }
                });
            }
        },

        async removeObject(parent, object) {

            // console.log('parent', parent);
            const parentTrigger = _.keys(parent.triggers)[0];
            let objectTrigger;
            let objectTriggerValue;

            objectTrigger = _.keys(object.triggers)[0];
            objectTriggerValue = JSON.parse(
                JSON.stringify(object.triggers[objectTrigger])
            );
            
            parent.triggers[parentTrigger] = objectTriggerValue;

            await this.$store
                .dispatch('updateObject', {
                    ...parent,
                })
                .then((editedObject) => {
                    const objectIndex = _.findIndex(this.items, {
                        _id: editedObject._id,
                    });
                    this.items.splice(objectIndex, 1, editedObject);
                    this.$store
                        .dispatch('deleteObject', object._id)
                        .then(() => {
                            this.$store.commit(
                                'REMOVE_OBJECT_FROM_PROJECT',
                                object._id
                            );
                        });

                    this.contentDraft = { owner: {}, location: {} };
                    this.previousObject = undefined;
                    this.objectType = undefined;
                    this.showCreation = false;
                    this.creationEnabled = false;
                    this.editionEnabled = false;
                    this.hasDelete = false;
                    this.selectedObject = "";

                    this.originalItem = {};
                    this.pointDraft = undefined;
                    this.mapPositionActive = false;
                    this.activeObject = {};
                });
        },
        canBlockWindow(e){
            // console.log(e)
            this.bellowLimit=e;
        },
        async createMulti(content){
            // console.log("(pas 4) content to save",this.contentDraft,content)
            if (
                !isEmptyObject(
                    _.omit(this.contentDraft, '_id', 'order', 'owner')
                )
            ) {
                if (this.creating == true) {
                    // console.log('cancelling input because  is creating');
                    return this.cancelInput();
                }

                this.creating = true;
                
                if (this.items.length > 1) {
                    this.contentDraft.order = this.items.length;
                } else {
                    this.contentDraft.order = 1;
                }

                let contentToSend = { ...this.contentDraft };
                /*let questions = [];
                if (contentToSend.questions) {
                    questions = { ...contentToSend.questions };
                }

                console.log(questions)*/

                if (this.isMultiLang) {
                    if (contentToSend.descriptionPerLang && _.isEmpty(contentToSend.descriptionPerLang)) {
                            // console.log("eliminant descriptionperlang")
                            delete contentToSend.descriptionPerLang;
                        }  
                    if (contentToSend.videoPerLang && _.isEmpty(contentToSend.videoPerLang)) {
                        // console.log("eliminant videoperlang")
                        delete contentToSend.videoPerLang;
                    }
                    if (contentToSend.urlPerLang && _.isEmpty(contentToSend.urlPerLang)) {
                        // console.log("eliminant urlperlang")
                        delete contentToSend.urlPerLang;
                    }
                    if (contentToSend.audioPerLang && _.isEmpty(contentToSend.audioPerLang)) {
                        // console.log("eliminant audioperlang")
                        delete contentToSend.audioPerLang;
                    }
                    if (contentToSend.filesPerLang && _.isEmpty(contentToSend.filesPerLang)) {
                        // console.log("eliminant filesperlang")
                        delete contentToSend.filesPerLang;
                    }
                    if (contentToSend.questions) {
                        // console.log("checking questions")
                        let questionsToSend = [];
                        let activeQuestion = {};
                        contentToSend.questions.forEach((question) => {
                            activeQuestion = { ...question };
                            if (question.descriptionPerLang && _.isEmpty(question.descriptionPerLang)) {
                                // console.log("eliminant descriptionperlang de la pregunta")
                                delete activeQuestion.descriptionPerLang;
                            }  
                            if (question.videoPerLang && _.isEmpty(question.videoPerLang)) {
                                // console.log("eliminant videoperlang de la pregunta")
                                delete activeQuestion.videoPerLang;
                            }
                            if (question.urlPerLang && _.isEmpty(question.urlPerLang)) {
                                // console.log("eliminant urlperlang de la pregunta")
                                delete activeQuestion.urlPerLang;
                            }
                            if (question.audioPerLang && _.isEmpty(question.audioPerLang)) {
                                // console.log("eliminant audioperlang de la pregunta")
                                delete activeQuestion.audioPerLang;
                            }
                            if (question.filesPerLang && _.isEmpty(question.filesPerLang)) {
                                // console.log("eliminant fileperlang de la pregunta")
                                delete activeQuestion.filesPerLang;
                            }
                            if (question.answersPerLang && !_.isEmpty(question.answersPerLang)) {
                                if (question.answersPerLang[this.$store.getters.project.defaultLang]) {
                                    // console.log("assignant resposta per defecte")
                                    question.answers = question.answersPerLang[this.$store.getters.project.defaultLang];
                                }
                            }
                            questionsToSend.push(activeQuestion);
                        })
                        contentToSend.questions = questionsToSend;
                    }
                }
                // console.log("content to send",contentToSend)
                await this.$store
                    .dispatch('createObject', {
                        ...contentToSend,
                        ...{ project: this.$route.params.projectId },
                    }).then((objectResult) => {
                        // console.log("closing creation",objectResult)
                        this.creating = false;
                        this.showCreation = false;
                        this.items = this.$store.getters.projectContent.filter(
                            function (item) {
                                return item['_id'] != 'draft';
                            }
                        );

                        this.creationEnabled = false;
                        this.contentDraft = { owner: {} };
                        if (this.pointDraft) {
                            this.pointDraft = undefined;
                        }

                        this.creating = false;
                        this.showCreation = false;
                        this.previousObject = undefined;
                        this.objectType = undefined;
                        this.selectedObject = "";
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        this.creating = false;
                    });

                
                
            } else {
                // console.log("empty object")
                this.cancelInput();
            }
        },
        updateOrCreateMulti(content) {
            // console.log("go to update or create",this.contentDraft._id,content)
            if (this.contentDraft._id != 'draft') {
                this.updateMulti(content);
            } else {
                this.createMulti(content);
            }
        },
        async updateMulti(content){
            
            // console.log("question group to save",content)

            let contentToSend = { ...content };
            if (this.isMultiLang) {
                if (contentToSend.descriptionPerLang && _.isEmpty(contentToSend.descriptionPerLang)) {
                    // console.log("eliminant descriptionperlang")
                    delete contentToSend.descriptionPerLang;
                }
                if (contentToSend.videoPerLang && _.isEmpty(contentToSend.videoPerLang)) {
                    // console.log("eliminant videoperlang")
                    delete contentToSend.videoPerLang;
                }
                if (contentToSend.urlPerLang && _.isEmpty(contentToSend.urlPerLang)) {
                    // console.log("eliminant urlperlang")
                    delete contentToSend.urlPerLang;
                }
                if (contentToSend.audioPerLang && _.isEmpty(contentToSend.audioPerLang)) {
                    // console.log("eliminant audioperlang")
                    delete contentToSend.audioPerLang;
                }
                if (contentToSend.filesPerLang && _.isEmpty(contentToSend.filesPerLang)) {
                    // console.log("eliminant filesperlang")
                    delete contentToSend.filesPerLang;
                }
                if (contentToSend.questions) {
                    // console.log("checking questions")
                    let questionsToSend = [];
                    let activeQuestion = {};
                    contentToSend.questions.forEach((question) => {
                        activeQuestion = { ...question }
                        if (question.descriptionPerLang && _.isEmpty(question.descriptionPerLang)) {
                            // console.log("eliminant descriptionperlang de la pregunta")
                            delete activeQuestion.descriptionPerLang;
                        }    
                        if (question.videoPerLang && _.isEmpty(question.videoPerLang)) {
                            // console.log("eliminant videoperlang de la pregunta")
                            delete activeQuestion.videoPerLang;
                        }
                        if (question.urlPerLang && _.isEmpty(question.urlPerLang)) {
                            // console.log("eliminant urlperlang de la pregunta")
                            delete activeQuestion.urlPerLang;
                        }
                        if (question.audioPerLang && _.isEmpty(question.audioPerLang)) {
                            // console.log("eliminant audioperlang de la pregunta")
                            delete activeQuestion.audioPerLang;
                        }
                        if (question.filesPerLang && _.isEmpty(question.filesPerLang)) {
                            // console.log("eliminant fileperlang de la pregunta")
                            delete activeQuestion.filesPerLang;
                        }
                        // console.log("comprovant answersPerLang",question.answersPerLang[this.$store.getters.project.defaultLang],)
                        if (question.answersPerLang && question.answersPerLang[this.$store.getters.project.defaultLang]) {
                            if (question.answersPerLang[this.$store.getters.project.defaultLang]) {
                                // console.log("assignant resposta per defecte")
                                activeQuestion.answers = question.answersPerLang[this.$store.getters.project.defaultLang];
                            }
                        }
                        questionsToSend.push(activeQuestion);
                    })
                    contentToSend.questions = questionsToSend;
                }
            }
            // console.log("content to send", contentToSend)
                
            await this.$store.dispatch('updateObject', {
                ...contentToSend,
            });
            this.editionEnabled = false;
            this.contentDraft = { owner: {} };
            if (this.pointDraft) {
                this.pointDraft = undefined;
            }
            if (this.activeObject) {
                this.activeObject = {};
            }
        },
        closeEditSession() {
            this.editingSession = false;
            this.fetchSession();
        }

    },
};
</script>

<style scoped lang="css">
@import '../assets/css/project.css';
@import '../assets/css/map.css';
@import '../assets/css/tippyedulocblue.css';
@import '../assets/css/swal-eduloc.css';

</style>
